/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

import { isValidFrequency } from '../../utilities/Validators';

function frequency(healthEntryState) {
  healthEntryState.frequency = healthEntryState.frequency || { id: null, value: '' };

  return {
    hasFrequency: () => !!healthEntryState.frequency.id,
    setId: (frequencyId) => { healthEntryState.frequency.id = frequencyId; },
    setValue: (value) => { healthEntryState.frequency.value = `${value}`; },
    set: (data) => { healthEntryState.frequency = data; },
    get: () => healthEntryState.frequency,
    getValue: () => healthEntryState.frequency.value,
    getId: () => healthEntryState.frequency.id,
    clear: () => { healthEntryState.frequency = { id: null, value: '' }; },
    isInvalid: () => !isValidFrequency(healthEntryState.frequency.value),
  };
}


export function cleanFrequency(healthEntryCategoryState) {
  const freqId = _.get(healthEntryCategoryState, 'frequency.id', '');
  if (freqId === '' || freqId === null) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['frequency']);
  }

  return healthEntryCategoryState;
}

export default frequency;
